import { render, staticRenderFns } from "./totalItem.vue?vue&type=template&id=b330505e&scoped=true&"
import script from "./totalItem.vue?vue&type=script&lang=js&"
export * from "./totalItem.vue?vue&type=script&lang=js&"
import style0 from "./totalItem.vue?vue&type=style&index=0&id=b330505e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b330505e",
  null
  
)

export default component.exports